import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import type { StatefulDiaryT } from "@/types/database/diaries";
import { Lightbulb } from "lucide-react";
import TrackerChart from "./TrackerChart";

interface Props {
	diary: StatefulDiaryT;
	disableAnimations?: boolean;
}

import NoDataPlaceholder  from "@/components/common/NoDataPlaceholders";

const DiaryCharts = ({ diary, disableAnimations = false }: Props) => {
	const hasTrackers = diary.trackers_view?.length > 0;
	const hasEntries = diary.trackers_view?.some(
		(tracker) => tracker.entries_view?.length > 0,
	);

	if (!hasTrackers || !hasEntries) {
		return <NoDataPlaceholder />;
	}

	return (
		<div className="space-y-6">
			{diary.trackers_view.map((tracker) => {
				if (!tracker) return null;

				const formattedTitle =
					tracker.form?.form_name
						?.split(" ")
						.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
						.join(" ") ?? "Unknown Tracker";
				const formattedDescription =
					tracker.form?.form_description
						?.split(" ")
						.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
						.join(" ") ?? "Unknown Tracker";

				return (
					<Card key={tracker.tracker_id} className="p-4">
						<CardHeader>
							<CardTitle className="font-semibold text-xl">
								{formattedTitle}
							</CardTitle>
							<CardDescription>{formattedDescription}</CardDescription>
						</CardHeader>
						<CardContent>
							<div className="print:min-w-[100%] print:min-h-[300px] print:scale-100">
								<TrackerChart
									disableAnimations={disableAnimations}
									tracker={tracker}
								/>
							</div>
						</CardContent>
					</Card>
				);
			})}
		</div>
	);
};

export default DiaryCharts;
